import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MessageBroadcastingService } from '../message-broadcasting.service';
import { Subject, Subscription } from 'rxjs';
import { BroadcastMessagesDatasource } from './broadcast-messages.datasource';
import { CdkScrollable, CdkVirtualScrollViewport, FixedSizeVirtualScrollStrategy, ScrollDispatcher, VIRTUAL_SCROLL_STRATEGY, CdkVirtualForOf } from '@angular/cdk/scrolling';
import { MatDialog } from '@angular/material/dialog';
import { MessageLogsDialogComponent } from '../message-logs/message-logs-dialog.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { BroadcastOneMessageComponent } from '../message/broadcast-one-message.component';

export class CustomVirtualScrollStrategy extends FixedSizeVirtualScrollStrategy {
  constructor() {
    // super(500, 600, new ItemSizeAverager(146));
    super(146, 500, 600);
  }
}

@Component({
    selector: 'app-broadcast-messages-grid',
    template: `
    <mat-progress-bar
      class="mat-progress-bar"
      mode="indeterminate"
      color="primary"
      *ngIf="messagesDatasource.loading$ | async"
    ></mat-progress-bar>
    <cdk-virtual-scroll-viewport cdkScrollable class="messages-viewport">
      <div
        *ngIf="!selectedBroadcastId && !messagesDatasource.loadingSubject.value && !messagingService.getNumbersInProgress"
        class="no-messages-container"
      >
        <mat-icon>podcasts</mat-icon>
        <h2>You haven't created a broadcast yet</h2>
        <p>Broadcasts are useful for sending out a mass message to which your customers cannot respond.</p>
        <div *ngIf="hasEditAccess && messagingService.selectedMessagingNumber?.allowSend">
          <button mat-flat-button color="primary" (click)="onNewBroadcast($event)">
            <mat-icon style="margin-right: 10px">add_circle</mat-icon>
            <span class="center-text">Compose A Broadcast</span>
          </button>
        </div>
      </div>
      <div
        *ngIf="
          selectedBroadcastId &&
          messagesDatasource.length === 0 &&
          !messagesDatasource.loadingSubject.value &&
          !messagingService.getNumbersInProgress
        "
        class="no-messages-container"
      >
        <mat-icon>visibility</mat-icon>
        <h2>Create a preview and send</h2>
        <p>
          Write your message in the box below and click ‘preview’ before sending it out to all contacts in this
          broadcast.
        </p>
      </div>
      <div *cdkVirtualFor="let item of messagesDatasource; let index = index">
        <app-broadcast-one-message
          *ngIf="!!item"
          [model]="item"
          [searchText]="searchText"
          class="item-{{ index }}"
          (showMessageLogs)="showMessageLogs($event)"
        ></app-broadcast-one-message>
        <div *ngIf="!item" class="loading-item">
          <div>Loading...</div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  `,
    styles: [
        '.messages-viewport {height: 100%; overflow: auto;}',
        '.loading-item {height: 146px; text-align: center} .loading-item div {padding-top: 70px}',
        '.mat-progress-bar {width: 100%; position: absolute; left: 0; top: 0}',
        '.no-messages-container {max-width: 420px; margin: 100px auto; text-align: center;}',
    ],
    providers: [{ provide: VIRTUAL_SCROLL_STRATEGY, useClass: CustomVirtualScrollStrategy }],
    standalone: true,
    imports: [
        NgIf,
        MatProgressBar,
        CdkVirtualScrollViewport,
        CdkScrollable,
        MatIcon,
        MatButton,
        CdkVirtualForOf,
        BroadcastOneMessageComponent,
        AsyncPipe,
    ],
})
export class BroadcastMessagesGridComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  private readonly TAG = '[BroadcastMessagesGridComponent]';
  @Output() newBroadcastClick = new EventEmitter();
  @Input() hasEditAccess: boolean;
  @Input() selectedPhoneNumber: string;
  @Input() selectedBroadcastId: string;
  @Input() searchText: string;

  @ViewChild(CdkScrollable) scrollContainer: CdkScrollable;
  @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;

  private shouldInitScroll = true;
  private fetchPageSubscription: Subscription;
  private deBouncer: Subject<SimpleChanges> = new Subject<SimpleChanges>();

  constructor(
    public messagingService: MessageBroadcastingService,
    public messagesDatasource: BroadcastMessagesDatasource,
    public scroll: ScrollDispatcher,
    public element: ElementRef,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    this.fetchPageSubscription = this.messagesDatasource.fetchPageEmitter.subscribe(value => {
      if (this.shouldInitScroll) {
        // this.shouldInitScroll = false;
        this.scrollToBottom();
      }
    });

    this.deBouncer.subscribe(value => {
      console.log(`${this.TAG} simple changes`, value);
      this.shouldInitScroll = true;
      if (this.selectedPhoneNumber && !!this.selectedBroadcastId) {
        this.messagesDatasource.onFilterDataChange({
          selectedBroadcastId: this.selectedBroadcastId,
          selectedPhoneNumber: this.selectedPhoneNumber,
          searchText: this.searchText,
        });
      } else {
        this.messagesDatasource.loadingSubject.next(false);
        this.messagesDatasource.resetList();
      }
    });

    this.deBouncer?.next(undefined);
  }

  scrollToBottom(): void {
    console.log('scrollToBottom 1');
    setTimeout(() => {
      console.log('scrollToBottom 2');
      this.virtualScroll.scrollToIndex(this.messagesDatasource.length - 1, 'auto');

      setTimeout(() => {
        console.log('scrollToBottom 3');
        this.virtualScroll.scrollToIndex(this.messagesDatasource.length - 1, 'auto');

        if (!this.isBottom()) {
          this.goToBottom();
        }
      }, 500);
    }, 300);
  }

  goToBottom() {
    if (!this.isBottom()) {
      const elm = this.virtualScroll.getElementRef().nativeElement;
      elm.scrollTop = elm.scrollHeight - elm.clientHeight;

      setTimeout(() => {
        this.goToBottom();
      }, 500);
    }
  }

  isBottom(): boolean {
    const elm = this.virtualScroll.getElementRef().nativeElement;
    const delta = elm.scrollHeight - (elm.scrollTop + elm.clientHeight);

    console.log(`Bottom Delta: ${delta}`);

    return delta < 1;
  }

  ngOnDestroy() {
    console.log(`${this.TAG} ngOnDestroy`);
    this.fetchPageSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(`${this.TAG} changes`, changes);
    this.deBouncer?.next(changes);
  }

  ngAfterViewInit(): void {
    console.log(`${this.TAG} ngAfterViewInit`);
    this.scrollContainer.elementScrolled().subscribe(value => {
      this.shouldInitScroll = this.isBottom();
    });
  }

  onNewBroadcast($event: MouseEvent) {
    this.newBroadcastClick.emit();
  }

  showMessageLogs($event: { type: string; threadKey: string }) {
    console.log($event);
    this.dialog.open(MessageLogsDialogComponent, {
      width: '90%',
      height: '90%',
      data: {
        type: $event.type,
        threadKey: $event.threadKey,
      },
    });
  }
}
